module.exports = __webpack_public_path__ + "img/log.6f0c4547.png";